import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Params } from '@angular/router';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';

import { BehaviorSubject, Observable } from 'rxjs';
import { NgIf, NgFor, AsyncPipe, KeyValuePipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

const HIDDEN_FEATURES = ['short_text', 'long_text', 'question_', 'answer_'];

@Component({
  selector: 'app-featured-specs-card',
  templateUrl: './featured-specs-card.template.html',
  styleUrls: ['./featured-specs-card.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, NgIf, NgFor, AsyncPipe, KeyValuePipe],
})
export class FeaturedSpecsCardComponent implements OnInit {
  @Input() public metadata?: Params | null;

  public readonly lessThan$: Observable<ScreenSizeInfoState>;
  public specList: Params = {};
  public hasSpecs: boolean;

  public readMore: boolean;

  public readonly contentExpanded$: Observable<boolean>;
  private readonly contentSubject: BehaviorSubject<boolean>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.contentSubject = new BehaviorSubject('' as any);
    this.contentExpanded$ = this.contentSubject.asObservable();

    this.hasSpecs = false;

    this.readMore = false;

    this.lessThan$ = this.akitaScreenQuery.selectLessThan();

    if (this.akitaScreenQuery.lessThan.sm) {
      this.contentSubject.next(false);
    } else {
      this.contentSubject.next(true);
    }
  }

  public ngOnInit() {
    if (this.metadata) {
      const features: any = this.metadata || {};
      const parsedFeatures: Params = {};
      for (const key of Object.keys(features)) {
        if (HIDDEN_FEATURES.some((x) => key.includes(x))) {
          continue;
        }
        const parsedName = `${key || ''}`;
        parsedFeatures[parsedName] = features[key];
      }
      for (const feat in parsedFeatures) {
        if (parsedFeatures[feat]) {
          this.specList[feat] = parsedFeatures[feat];
        }
      }

      if (Object.keys(this.specList).length !== 0) {
        this.hasSpecs = true;
      }
      // this.specList = this.phoneMetadata.features.filter((x: string) => x !== '');
    }
  }

  public switchExpanded(): void {
    if (this.contentSubject.value) {
      this.contentSubject.next(false);
    } else {
      this.contentSubject.next(true);
    }
  }

  public collapseAndScroll(): void {
    this.readMore = !this.readMore;
    if (
      this.akitaRouterQuery.isBrowser &&
      window.document &&
      window.document.getElementById
    ) {
      const scrollElement = window.document.getElementById('mainAppScroll');
      if (scrollElement) {
        if (scrollElement.scrollTo) {
          scrollElement.scrollTo({
            top: 500,
            left: 0,
            behavior: 'smooth',
          });
        } else {
          scrollElement.scrollTop = 500;
        }
      }
    }
  }

  public trackByKey(index: number, value?: any | null): string {
    return `${value || index}`;
  }
}
